module.exports = __webpack_public_path__ + "img/service3.216f3d53.png";